import { render, staticRenderFns } from "./FgRequestModal.vue?vue&type=template&id=9fc11628&"
import script from "./FgRequestModal.vue?vue&type=script&lang=js&"
export * from "./FgRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports